import { render, staticRenderFns } from "./PointInformationCard.vue?vue&type=template&id=3d550bfd&scoped=true&"
import script from "./PointInformationCard.vue?vue&type=script&lang=ts&"
export * from "./PointInformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./PointInformationCard.vue?vue&type=style&index=0&id=3d550bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d550bfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
